import React, { useContext } from "react";
import { useState } from "react";
import { Mentionable } from "../../../../../../common/sesh_types";
import { trpc } from "../../../utils/trpc";
import { useGuildMemberCache } from "./use_guild_member_cache";

export const GuildMemberContext = React.createContext<{
	members: Map<string, Mentionable[]>;
	getMembers: (guild_id: string) => Mentionable[];
	addMembers: (guild_id: string, members: Mentionable[]) => void;
}>(null);

export function useGuildMemberQuery(guild_id: string, ids: string[]) {
	const members_cache = useGuildMemberCache();

	const members_for_guild = members_cache.getMembers(guild_id);

	const recordified_members: Record<string, Mentionable> =
		members_for_guild.reduce((acc, val) => {
			acc[val.id] = val;
			return acc;
		}, {});

	const members_to_fetch = ids.filter((val) => !recordified_members[val]);

	const members_query = trpc.members.get.useQuery(
		{
			guild_id,
			ids: members_to_fetch,
		},
		{
			staleTime: Infinity,
			enabled: members_to_fetch.length > 0,
			onSuccess: (data) => {
				members_cache.addMembers(guild_id, data);
			},
		}
	);

	return {
		is_loading: members_query.fetchStatus === "fetching",
		members: ids
			.map((val) => recordified_members[val])
			.filter((val) => val),
	};
}
